export class Login {
    public name: string;
    public mobile: string;
    public pincode: string;
}